import script from "./NewOurProjectsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewOurProjectsPage.vue?vue&type=script&setup=true&lang=js"

import "./NewOurProjectsPage.vue?vue&type=style&index=0&id=43756b48&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43756b48"]])

export default __exports__